import _ from 'underscore';
import * as putil from '@bingads-webui-universal/primitive-utilities';

let Permissions;

export function initialize({
  globalConfig,
}) {
  Permissions = globalConfig.get('Permissions');
}

export function updateEntitySchemaForSOV(originalSchema, copy = true) {
  function isFilterable(schemaName, propName) {
    let schemaNameWhiteList = [
      'Account',
      'Campaign',
      'AdGroup',
      'Keyword',
      'Time',
      // Comment out PortfolioBidStrategy until backend ready.
      // 'PortfolioBidStrategy',
      'Budget',
    ];
    const propNameBlackList = _.compact([
      'AuctionLostToLandingPercent',
      'AuctionLostToAdQualityPercent',
      'AuctionLostToBidPercent',
      schemaName === 'DimensionShopping' && 'TopImpressionRate',
      schemaName === 'ProductGroup' && 'TopImpressionRate',
    ]);

    if (Permissions.IsAvgPositionDeprecationPhase1Enabled
      && _.contains([
        'TopImpressionRatePercent',
        'TopImpressionRate',
        'AbsoluteTopImpressionRatePercent',
        'AbsoluteTopImpressionRate',
      ], propName)) {
      schemaNameWhiteList = schemaNameWhiteList.concat([
        'Ad', 'SearchTerm', 'DsaSearchTerm',
        'DsaTarget', 'BiddableAdGroupCriterion',
        'BiddableCampaignCriterion', 'ProductGroup',
        'DimensionLanding', 'DimensionSearchTerm', 'DimensionPublisher',
        'Time', 'DimensionGeographic', 'DimensionLocation',
        'DimensionShopping', 'AudienceCriterionWithBI',
      ]);
    }

    return _.contains(schemaNameWhiteList, schemaName) && !_.contains(propNameBlackList, propName);
  }

  const schema = (copy ? putil.cloneDeep : _.identity)(originalSchema);
  const performanceMetrics = putil.get(schema, 'properties.PerformanceMetrics');
  const performanceMetricsProperties = putil.get(performanceMetrics, 'schema.properties');

  if (performanceMetricsProperties) {
    const propsToAdd = _.chain(performanceMetricsProperties)
      .pairs()
      .filter(([propName, prop]) =>
        prop.sovcolumn && isFilterable(schema.name, propName))
      .map(_.first)
      .value();

    if (_.isArray(performanceMetrics.filterable)) {
      performanceMetrics.filterable = _.chain(performanceMetrics.filterable)
        .union(propsToAdd)
        .value();
    } else {
      _.each(performanceMetricsProperties, (prop, propName) => {
        if (_.contains(propsToAdd, propName)) {
          // eslint-disable-next-line no-param-reassign
          prop.filterable = true;
        }
      });
    }
  }

  return schema;
}
